<div class="button"
  [ngClass]="disabled ? 'disabledBtn' : 'normal'"
  (pointerenter)="onPointerEnter()"
  (pointerleave)="onPointerLeave()"
  (pointerdown)="onPointerDown()"
  (pointerup)="onPointerUp()"
  (click)="onClick()">
  <div class="inData">
    <ng-content></ng-content>
  </div>
</div>
